export default function (price, fractionDigits = 2) {
	return price.toFixed(fractionDigits).replace(/\./,',')
}
